import { gara } from './../../model/Gara';
import { Component, OnInit, Input } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AlertController, ModalController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { AuthenticateService } from '../services/authentication.service';

@Component({
  selector: 'app-creagara',
  templateUrl: './creagara.page.html',
  styleUrls: ['./creagara.page.scss'],
})


export class CreagaraPage implements OnInit {
  gara: gara = new gara();
  validations_form: FormGroup;
  @Input() idgara: string;
  @Input() action: string;
  @Input() type: string;
  constructor(private fireStore: AngularFirestore, public auth: AuthenticateService, public formBuilder: FormBuilder, public modal: ModalController, 
    private alertController: AlertController) { }

  ngOnInit() {
    this.validations_form = new FormGroup({
      nome: new FormControl(),
      data: new FormControl(),
      n_bersagli: new FormControl('', Validators.compose([
        Validators.required,
        targetvalidator
      ])),
      ordine:new FormControl()
      // schema: new FormControl(),
      // tiratore1: new FormControl(),
      // tiratore2: new FormControl(),
      // tiratore3: new FormControl(),
      // tiratore4: new FormControl(),
      // tiratore5: new FormControl(),
      // tiratore6: new FormControl(),
    });

    if (this.action == 'mod') {
      this.fireStore.collection<any>('gara').doc(this.idgara).get().subscribe((r) => {
        this.validations_form.controls.data.setValue(r.data().data);
        this.validations_form.controls.nome.setValue(r.data().nome);
        this.validations_form.controls.n_bersagli.setValue(r.data().n_bersagli);
        this.validations_form.controls.ordine.setValue(r.data().ordine);
      });

    }
  }
  crea() {
    // this.gara.matrice = [];
    if (!this.validations_form.valid) {
      this.gara.nome = this.validations_form.value.nome;
      this.gara.data = this.validations_form.value.data;
      this.gara.n_bersagli = this.validations_form.value.n_bersagli;
      this.gara.ordine = this.validations_form.value.ordine;
      this.gara.admin = [];
      // this.gara.schema = this.validations_form.value.schema;
      // this.gara.matrice[0] = this.validations_form.value.tiratore1;
      // this.gara.matrice[1] = this.validations_form.value.tiratore2;
      // this.gara.matrice[2] = this.validations_form.value.tiratore3;
      // this.gara.matrice[3] = this.validations_form.value.tiratore4;
      // this.gara.matrice[4] = this.validations_form.value.tiratore5;
      // this.gara.matrice[5] = this.validations_form.value.tiratore6;

      // //console.log.value);
      let obj = {};
      for (let p in this.gara) {
        obj[p] = this.gara[p];
      }
      obj['user_id'] = this.auth.user_logged.uid;
      obj['user_invited'] = [];
      obj['premio'] = [];
      obj['archiviata'] = false;
      obj['type'] = this.type;
      if (this.action == 'mod') {
        this.fireStore.collection<any>('gara').doc(this.idgara).update(obj).then(() => {
          this.presentAlert();
          this.modal.dismiss();
        })
      }
      else {
        obj['user_invited'] = [];
        this.fireStore.collection<any>('gara').add(obj).then(() => {
          this.presentAlert();
          this.modal.dismiss();
        })
      }
    }
    else {
      this.presentError();
    }
  }

  close() {
    this.modal.dismiss();
  }

  async presentError() {
    let obj_alert = {
      header: 'Errore',
      subHeader: 'Errore',
      message: 'Errore nell\'impostazione dei bersagli',
      buttons: ['OK']
    }

    const alert = await this.alertController.create(obj_alert);

    await alert.present();
  }
  async presentAlert() {
    //console.logthis.action);

    if (this.action == 'mod') {
      let obj_alert = {
        header: this.type,
        subHeader: 'Modifica',
        message: this.type + ' modificata con successo',
        backdropDismiss: false,
        buttons: ['OK']
      }
      const alert = await this.alertController.create(obj_alert);
      await alert.present();
    }
    else {
      let obj_alert = {
        header:  this.type,
        subHeader: 'Creazione',
        message:  this.type+' creata con successo',
        backdropDismiss: false,
        buttons: ['OK']
      }
      const alert = await this.alertController.create(obj_alert);
      await alert.present();
    }


  }

}


export function targetvalidator(control: AbstractControl) {
  if (control.value % 25 == 0) {
    return { urlValid: true };
  }
  return null;
}